import React from 'react';

export const BodyPortalSlotsContext = React.createContext<string[]>(['root']);
